<template>
  <div
    v-if="loading"
    class="la-ball-clip-rotate-pulse"
  >
    <div />
    <div />
  </div>
  <icon
    v-else
    :icon="icon"
  />
</template>

<script>
export default {
  props: {
    loading: {
      required: true,
      type: Boolean,
    },

    icon: {
      required: true,
      type: String,
    },

    loadingButtonIcon: {
      required: false,
      type: String,
      default: 'fa-spin',
    },
  },
}
</script>
